// AddItemComps/ProductDetails.js
import React, { useEffect, useState } from 'react';
import FileUpload from './FileUpload/FileUpload';

const ProductDetails = ({ onDataChange, initialValues = {} }) => {

    const [name, setName] = useState(initialValues.name || '');
    const [price, setPrice] = useState(initialValues.price || '');
    const [quantity, setQuantity] = useState(initialValues.quantity || '');
    const [description, setDescription] = useState(initialValues.description || '');

    useEffect(() => {
        setName(initialValues.name || '');
        setPrice(initialValues.price || '');
        setQuantity(initialValues.quantity || '');
        setDescription(initialValues.description || '');
    }, [initialValues]);
    const handleNameChange = (e) => {
        setName(e.target.value);
        notifyParent();
    };

    const handlePriceChange = (e) => {
        setPrice(e.target.value);
        notifyParent();
    };
    const handleQuantityChange = (e) => {
        setQuantity(e.target.value);
        notifyParent();
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
        notifyParent();
    };


    const notifyParent = () => {
        onDataChange({ name, price, quantity, description });
    };

    return (
        <div>
            <h3>Product Details</h3>
            <input
                type="text"
                placeholder="Product Name"
                value={name}
                onChange={handleNameChange}
            />
            <input
                type="number"
                placeholder="Price"
                value={price}
                onChange={handlePriceChange}
            />
            <input
                type="number"
                placeholder="Quantity"
                value={quantity}
                onChange={handleQuantityChange}
            />
            <textarea
                placeholder="Product Description"
                value={description}
                onChange={handleDescriptionChange}
            ></textarea>
            <FileUpload
                label="Choose Files"
            />
        </div>
    );
};


export default ProductDetails;
